import { render, staticRenderFns } from "./invChange.vue?vue&type=template&id=4f5c42d1&scoped=true"
import script from "./invChange.vue?vue&type=script&lang=js"
export * from "./invChange.vue?vue&type=script&lang=js"
import style0 from "./invChange.vue?vue&type=style&index=0&id=4f5c42d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c42d1",
  null
  
)

export default component.exports